<template lang="html">
  <div class="container text-center">
    <h1 class="center">Auswertung</h1>
    <template>
      <b-card
        no-body
        class="mb-4"
        v-for="(item, index) in groupdQuestions"
        v-bind:key="item.id"
      >
        <b-card-header header-tag="header" class="card-header">
          <div class="d-flex flex-row justify-content-between">
            <div>{{ groupdQuestions[index].nameLeft }}</div>
            <div>vs.</div>
            <div>{{ groupdQuestions[index].nameRight }}</div>
          </div>
        </b-card-header>
        <b-card-body class="card-body">
          <div class="row mt-2">
            <div class="col col-centered">
              <vue-slider
                :value="calcAvgCatResult(index)"
                :tooltip="'none'"
                :marks="marks1"
                :process="false"
                :dot-style="{ backgroundColor: '#36abff' }"
                :disabled="true"
                :dotSize="20"
                :id="`slider-input'${index}`"
              ></vue-slider>
            </div>
          </div>

          <div class="row mt-2"></div>
        </b-card-body>
      </b-card>

      <b-card no-body class="mb-4">
        <b-card-header header-tag="header" class="card-header">
          <div class="d-flex flex-row justify-content-between">
            <div>Job-Empfehlung</div>
          </div>
        </b-card-header>
        <b-card-body class="card-body">
          <div class="row mt-2 text-left">
            <div style="white-space: pre-wrap">{{ gptAnswer }}</div>
          </div>

          <div class="row mt-2"></div>
        </b-card-body>
      </b-card>
    </template>
    <div class="text-center">
      <br />
      <router-link class="btn btn-outline-primary" to="/signedin"
        >Zurück</router-link
      >
    </div>
  </div>
</template>

<script>
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/antd.css";

export default {
  props: ["id"],
  data() {
    return {
      questionid: 0,
      key: 0,
      groupdQuestions: null,
      groupedScales: null,
      // value: [5,10], // for multipe dots
      value: 0, //für einen Dot
      userid: null,
      gptPrompt: null,
      gptAnswer: null,

      marks1: {
        1: "stark",
        25: "eher",
        50: "neutral",
        75: "eher",
        100: "stark",
      },
    };
  },

  methods: {
    reset(key) {
      this.questionid = 0;
      this.key = key;
    },

    // getItems() {
    //   this.$user
    //     .getGroupedQuestionsForEvaluation(this.userid)
    //     .then((response) => {
    //       this.groupdQuestions = response;
    //     });
    // },

    createPrompt(scales) {
      // groupedScales-Felder
      // scaleAvg, scaleCount, scaleSum
      // this.groupedScales;

      let likertVal = null;
      let prompt = "";

      prompt =
        "Du bist ein freundlicher Berufsberater für Menschen, die eine Berufsausbildung machen möchten und berätst mich den richtigen Beruf zu finden. Ich habe folgende Persönlichkeitsmerkmale: ";

      scales.forEach((scale) => {
        // Bis zu welchem Punkt gilt der wert z.B. 0-20 unwichtig, 21-40 eher unwichtig, 41-60 neutral, 61-80 eher wichtig, 81-100 wichtig
        // wird zur PRomptgenerierung benötigt
        switch (true) {
          case scale.scaleAvg >= 0 && scale.scaleAvg <= 20:
            likertVal = "ist mir unwichtig";
            break;
          case scale.scaleAvg >= 21 && scale.scaleAvg <= 40:
            likertVal = "ist mir eher unwichtig";
            break;
          case scale.scaleAvg >= 41 && scale.scaleAvg <= 60:
            likertVal = "stehe ich neutral gegenüber";
            break;
          case scale.scaleAvg >= 61 && scale.scaleAvg <= 80:
            likertVal = "ist mir eher wichtig";
            break;
          case scale.scaleAvg >= 81 && scale.scaleAvg <= 100:
            likertVal = "ist mir wichtig";
            break;
          default:
            likertVal = "Ungültiger Wert";
        }

        prompt = prompt + scale.scaleName + " " + likertVal + ". ";
      });

      prompt =
        prompt +
        "Bitte liste mir 5 mögliche Berufe auf, die zu mir passen könnten. Bitte verwende dabei nur offiziell aneerkannte Berufe der IHK oder HWK.";

      return prompt;
      //console.log(prompt);
    },

    getGptAnswer(gptPrompt) {
      this.$openai.askChatGPT(gptPrompt).then((response) => {
        this.gptAnswer = response.completion;
      });
    },

    // catIndex is the index of the category, for each category calculate sum up the valid values
    calcAvgCatResult(catIndex) {
      let maxValue = this.groupdQuestions[catIndex].data[0].maxValue;

      let res = 0;
      let isInverted = false;
      let currentValue = 0;
      let sumValue = 0;
      let countValidValues = 0;

      for (let i = 0; i < maxValue; i++) {
        isInverted = this.groupdQuestions[catIndex].data[i].itm_isinverted;

        // check if is inverted, if yes 100 - value
        if (isInverted == true) {
          currentValue =
            100 - this.groupdQuestions[catIndex].data[i].user_items[0].value;
        } else {
          currentValue =
            this.groupdQuestions[catIndex].data[i].user_items[0].value;
        }

        if (currentValue > 0) {
          sumValue = sumValue + currentValue;
          countValidValues++;
        }
      }

      res = Math.round(sumValue / (1 + countValidValues));

      return res;
    },

    updateQuestionValue(item) {
      this.$item.updateItem(item, this.userid);
    },
  },

  async created() {
    try {
      // Get User-ID
      this.userid = await this.$router.app.jwtHandler.getIdByJWT();
      // Erhalte Gruppierte Antworten
      this.groupdQuestions = await this.$user.getGroupedQuestionsForEvaluation(
        this.userid
      );
      // Verdichte Antworten
      this.groupedScales = await this.$user.CalcScaledAnswersForEvaluation(
        this.groupdQuestions
      );
      this.gptPrompt = this.createPrompt(this.groupedScales);
      // Bereite Antworten als Text-String auf
      // createPrompt
      this.gptAnswer = this.getGptAnswer(this.gptPrompt);
    } catch (error) {
      console.log(error);
    }
  },

  components: {
    VueSlider,
  },

  watch: {
    $route() {},
  },
};
</script>

<style scoped></style>
